import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import {
  LaktacijuAmziai,
  LaktozesGrupes,
  RBGrupes,
  SomatiniuGrupes,
  UrejosGrupes,
} from "../../constants/ParametruGrupes";
import styled from "@emotion/styled";
import GrupiuSelectItem from "./GrupiuSelectItem";
import VeisliuSelect from "../home/VeisliuSelect";
import useBreakpoints from "../../styles/windowSizes";

export const FlexColumnBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 0px;
`;

const GrupiuSelectList = ({
  veisliuList,
  veisles,
  changeVeisles,
  laktacijos,
  changeLaktacijas,
  slsGrupes,
  changeSlsGrupes,
  rbGrupes,
  changeRbGrupes,
  urejosGrupes,
  changeUrejosGrupes,
  laktozesGrupes,
  changeLaktozesGrupes,
}) => {
  const { isXxs } = useBreakpoints();

  const pasirinkimai = [
    {
      pavadinimas: "Amžius laktacijomis",
      grupes: LaktacijuAmziai,
      duomenys: laktacijos,
      keisti: changeLaktacijas,
    },
    {
      pavadinimas: "SLS",
      grupes: SomatiniuGrupes,
      duomenys: slsGrupes,
      keisti: changeSlsGrupes,
    },
    {
      pavadinimas: "R/B",
      grupes: RBGrupes,
      duomenys: rbGrupes,
      keisti: changeRbGrupes,
    },
    {
      pavadinimas: "Urėja",
      grupes: UrejosGrupes,
      duomenys: urejosGrupes,
      keisti: changeUrejosGrupes,
    },
    {
      pavadinimas: "Laktozė",
      grupes: LaktozesGrupes,
      duomenys: laktozesGrupes,
      keisti: changeLaktozesGrupes,
    },
  ];

  return (
    <Grid container spacing={2} size={12}>
      <Grid size={{ xs: isXxs ? 12 : 6, sm: 6, md: 4, lg: 12, xl: 12 }} key="veisles">
        <VeisliuSelect veisliuList={veisliuList} veisles={veisles} changeVeisles={changeVeisles} />
      </Grid>
      {pasirinkimai.map((grupe) => (
        <Grid size={{ xs: isXxs ? 12 : 6, sm: 6, md: 4, lg: 12, xl: 12 }} key={grupe.pavadinimas}>
          <GrupiuSelectItem
            pavadinimas={grupe.pavadinimas}
            grupes={grupe.grupes}
            pasirinktos={grupe.duomenys}
            changeGrupes={grupe.keisti}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default GrupiuSelectList;
